import { IsArray } from "@pdfking/tfunc"

export const is_object = obj => obj instanceof Object && !IsArray(obj)
